// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__10nfJ","requiredAsterisk":"Info_requiredAsterisk__6rpKP"};